// extracted by mini-css-extract-plugin
export default {"emailAddressField":"SubmitOrderToPosFormControl_emailAddressField__Zz1Tn"};